<template>
  <div>
    <el-dialog
      :visible="visible"
      title="Вход на цифровую платформу"
      custom-class="login-form-modal"
      append-to-body
      @close="$emit('update:visible', false)"
    >
      <el-form ref="loginForm" :model="formData" :rules="rules" class="login-form">
        <el-form-item prop="login" :error="errors.login">
          <label>
            <span>Логин</span>
            <el-input v-model="formData.login" size="small" />
          </label>
        </el-form-item>
        <el-form-item prop="password" :error="errors.password">
          <label>
            <span>Пароль</span>
            <el-input v-model="formData.password" type="password" size="small" />
          </label>
        </el-form-item>
        <el-form-item class="login-form__actions">
          <router-link class="login-form__link" to="/">
            Забыли пароль?
          </router-link>
          <el-button type="success" size="small" @click.prevent="login">
            Войти
          </el-button>
        </el-form-item>
      </el-form>
      <Divider>
        или
      </Divider>
      <SocialButtons />
    </el-dialog>
  </div>
</template>

<script>
import Divider from '@/components/Common/Divider'
import SocialButtons from '@/components/Auth/SocialButtons'

export default {
  name: 'ModalLogin',
  components: { SocialButtons, Divider },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },

  data() {
    const validatePassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Пожалуйста, введите пароль'))
        return
      }
      callback()
    }

    const validateLogin = (rule, value, callback) => {
      const correct = /^.+@.+\..+$/gim.test(value)

      if (value === '') {
        callback(new Error('Пожалуйста, введите e-mail'))
      }
      if (!correct) {
        callback(new Error('Пожалуйста, введите корректный e-mail'))
      }
      callback()
    }

    return {
      formData: {
        login: '',
        password: ''
      },
      errors: {
        login: '',
        password: ''
      },

      rules: {
        password: [{ validator: validatePassword, trigger: 'blur' }],
        login: [{ validator: validateLogin, trigger: 'blur' }]
      }
    }
  },

  methods: {
    login() {
      this.$refs.loginForm.validate(valid => {
        if (!valid) {
          return
        }
        localStorage.setItem('auth', 'true')
        localStorage.setItem('role', 'user')
        this.$router.push('/users/student/education')
      })
    }
  }
}
</script>

<style scoped lang="scss">
.login-form {
  margin: 0 36px;

  @include md-and-down {
    margin: 0;
  }

  &__actions {
    &::v-deep .el-form-item__content {
      display: flex;
      align-items: center;
      justify-content: space-between;

      &:after,
      &:before {
        display: none;
      }
    }
  }

  &__link {
    font-family: 'PFCentroSansPro', sans-serif;
    font-size: 16px;
    line-height: 19px;
    letter-spacing: 0.35px;
    text-decoration-line: underline;
    color: $luchmara;
  }
}
</style>

<style lang="scss">
.login-form-modal {
  width: 498px !important;

  @include sm-and-down {
    width: 100% !important;
  }
}
</style>
